export default "__VITE_ASSET__qMKWE5vU__"